module.exports = __webpack_public_path__ + "static/media/603JamesPBrawleyDr_2018-06-12_109.948e182c.jpg";